// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var Options__PropertyType = require("../../../reason/common/types/options/Options__PropertyType.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var Options__RentalPropertyType = require("../../../reason/common/types/options/Options__RentalPropertyType.bs.js");
var PropertyWizardRelayKeyFactsPropertyType_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPropertyType_draft_graphql.bs.js");
var PropertyWizardFormRelay__Validators__KeyFacts__PropertyType = require("./PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.bs.js");
var PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes = require("./PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPropertyType_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var DraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var DraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardRelayKeyFactsPropertyType_draft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var DraftFragment = {
  forSalePropertyTypeEnumV5_decode: DraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: DraftFragment_forSalePropertyTypeEnumV5_fromString,
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  rentalPropertyTypeEnumV5_decode: DraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: DraftFragment_rentalPropertyTypeEnumV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__PropertyType(props) {
  var stepHasBeenTouched = props.stepHasBeenTouched;
  var draft = use(props.draft);
  var draftProperty = draft.draftProperty;
  var rentalPropertyType = draftProperty.rentalPropertyType;
  var forSalePropertyType = draftProperty.forSalePropertyType;
  var isPropertyTypeValid = PropertyWizardFormRelay__Validators__KeyFacts__PropertyType.PropertyType.useIsValid(draft.fragmentRefs);
  var forSalePropertyTypeOption = Core__Option.map(forSalePropertyType, Options__PropertyType.make);
  var rentalPropertyTypeOption = Core__Option.map(rentalPropertyType, Options__RentalPropertyType.make);
  var forSalePropertyType$1 = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.forSalePropertyType = value;
            return newrecord;
          })
      }, stepHasBeenTouched, forSalePropertyType, isPropertyTypeValid);
  var rentalPropertyType$1 = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (current, value) {
            var newrecord = Caml_obj.obj_dup(current);
            newrecord.rentalPropertyType = value;
            return newrecord;
          })
      }, stepHasBeenTouched, rentalPropertyType, isPropertyTypeValid);
  var tmp;
  if (draftProperty.propertyType === "FOR_SALE") {
    var match = forSalePropertyType$1.valid;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                  getOptionLabel: Options__PropertyType.getOptionLabel,
                  getOptionValue: Options__PropertyType.getOptionValue,
                  isClearable: true,
                  onBlur: (function (param) {
                      forSalePropertyType$1.onBlur();
                    }),
                  onChange: (function (value) {
                      forSalePropertyType$1.onChange(value !== undefined ? value.value : undefined);
                    }),
                  options: Options__PropertyType.defaultOptions,
                  value: forSalePropertyTypeOption,
                  status: match !== undefined ? (
                      typeof match === "object" ? "Failure" : "Success"
                    ) : "Neutral"
                }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
                  valid: forSalePropertyType$1.valid
                })
          ]
        });
  } else {
    var match$1 = rentalPropertyType$1.valid;
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
                  getOptionLabel: Options__RentalPropertyType.getOptionLabel,
                  getOptionValue: Options__RentalPropertyType.getOptionValue,
                  isClearable: true,
                  onBlur: (function (param) {
                      rentalPropertyType$1.onBlur();
                    }),
                  onChange: (function (value) {
                      rentalPropertyType$1.onChange(value !== undefined ? value.value : undefined);
                    }),
                  options: Options__RentalPropertyType.defaultOptions,
                  value: rentalPropertyTypeOption,
                  status: match$1 !== undefined ? (
                      typeof match$1 === "object" ? "Failure" : "Success"
                    ) : "Neutral"
                }),
            JsxRuntime.jsx(Form__Components.FieldError.make, {
                  valid: rentalPropertyType$1.valid
                })
          ]
        });
  }
  return JsxRuntime.jsx(FormV5.FormSection.make, {
              children: JsxRuntime.jsxs(CssGrid.Grid, {
                    children: [
                      JsxRuntime.jsxs(CssGrid.Cell, {
                            width: 12,
                            widthMd: 4,
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Property Type"
                                  }),
                              tmp
                            ]
                          }),
                      JsxRuntime.jsx(PropertyWizardRelay__KeyFacts__PropertyType__PropertyAttributes.make, {
                            draft: draft.fragmentRefs,
                            stepHasBeenTouched: stepHasBeenTouched
                          })
                    ]
                  })
            });
}

var Components;

var FormSection;

var Grid;

var Cell;

var PropertyAttributes;

var Validators;

var FormUtils;

var make = PropertyWizardRelay__KeyFacts__PropertyType;

exports.Components = Components;
exports.FormSection = FormSection;
exports.Grid = Grid;
exports.Cell = Cell;
exports.PropertyAttributes = PropertyAttributes;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* FormV5 Not a pure module */
